import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=77932326&scoped=true&"
import script from "./Ward.vue?vue&type=script&lang=js&"
export * from "./Ward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77932326",
  null
  
)

export default component.exports